import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { AppBarTop } from '@/components/layout/AppBarTop';
import { Sidebar, SIDEBAR_WIDTHS } from '@/components/layout/Sidebar';
import { useUIStore } from '@/stores/uiStore';

export function MainLayout(): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const sidebarOpen = useUIStore((s) => s.sidebarOpen);
  const mobileDrawerOpen = useUIStore((s) => s.mobileDrawerOpen);
  const setMobileDrawerOpen = useUIStore((s) => s.setMobileDrawerOpen);

  const sidebarWidth = isMobile
    ? 0
    : sidebarOpen
      ? SIDEBAR_WIDTHS.open
      : SIDEBAR_WIDTHS.collapsed;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <AppBarTop />
      <Sidebar
        desktopOpen={sidebarOpen}
        mobileOpen={mobileDrawerOpen}
        onCloseMobile={() => setMobileDrawerOpen(false)}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          width: { md: `calc(100% - ${sidebarWidth}px)` },
          ml: { md: `${sidebarWidth}px` },
          transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Toolbar />
        <Box sx={{ p: { xs: 2, md: 3 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
